import React, {Component, createRef} from 'react';

// CSS
import '../Courses/Courses.scss';

// Helper
import {setCookie, checkCookie} from '../../Helper/Cookies';
import { apiFetch, getCurrentUser } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { Panel, Confirm } from '../../components/UI/Overlays';
import { EmptyState, TableWait, Tip } from '../../components/UI/Feedback';
import { Toolbar, SelectEmpty } from '../../components/UI/Controls';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FileUpload } from 'primereact/fileupload';

// Properties
const properties = require('../../properties.json');

class Reparation extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        // Submit Button
        buttonText: "إضافة تعويض",
        buttonColor: "",

        // Teacher Identifier
        branchID: getCurrentUser()?.branchId,
        companyID: properties.company_id,
        globalFilter: null,
        grade: null,
        material: null,

        getMaterialsList: [],
        // All Grades
        allGrades: [],
        // Get Data
        data:[],

        schoolStageId : null ,

        // adding happens in a panel from this page now, not in a card wedged
        // into the table's own header row
        addOpen: false,
        saving: false,

        // id -> name, so a row can name its stage and material instead of
        // showing the numbers the response carries
        stagesById: {},
        materialsById: {},

        // the rows are on their way
        tableLoading: true,
        loadingGrades: true,
        loadingMaterials: false,

        // the appointment the teacher asked to delete, held while the confirm
        // is on screen. The delete behind it is the same call it always was.
        doomed: null,
        deleting: false,

        formContent: {
            branchId: getCurrentUser()?.branchId,
            companyId: properties.company_id,
            thumb: "",
        }

    }

     getMaterialByStage = (schoolStagesId) => {
        this.setState({ loadingMaterials: true });
        // Get Materials From API
        apiFetch("/lookup/materials/by-stage", { query: { stageId: schoolStagesId } })
          .then((fetchMaterials) => {
            this.setState({
              getMaterialsList: fetchMaterials,
              loadingMaterials: false,
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            this.setState({ loadingMaterials: false });
          });
      };

    // Every material the teacher has, for turning a row's materialId into the
    // name they know it by -- a row can belong to any stage, so the per-stage
    // lookup the form uses is not enough here.
    getAllMaterials = () => {
        const user = getCurrentUser();
        apiFetch("/lookup/materials", { query: { branchId: user?.branchId, teacherUserId: user?.userId } })
          .then((materials) => {
            const materialsById = {};
            materials.forEach((m) => { materialsById[m.id] = m.name; });
            this.setState({ materialsById });
          })
          .catch((error) => console.error("Error:", error));
    };

    componentDidMount () {
        document.title = properties.site_name + " | التعويضات";
        this.allNews();
        this.getAllMaterials();
       // Redirect To Sign In Page If The User Is Already Logged Out & Remove The Data If It Exists
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
        };

        apiFetch("/lookup/school-stages/by-teacher", { query: { teacherUserId: getCurrentUser()?.userId } })
          .then((grades) => {
            const stagesById = {};
            grades.forEach((g) => { stagesById[g.id] = g.name; });
            this.setState({ allGrades: grades, stagesById, loadingGrades: false });
          })
          .catch((error) => {
            console.error("Error:", error);
            this.setState({ loadingGrades: false });
          });
    }

    allNews = () => {
        var _this = this ;
       this.setState({ tableLoading: true });
       // Send the data to the server
       apiFetch("/other-appointments")
       .then(done => {
        this.setState({data : done, tableLoading: false});

       })
       .catch(error => {
           console.error('Error:', error)
           this.setState({ tableLoading: false });
           _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
       });
   };

     addNews = () => {
        var _this = this ;
       this.setState({ saving: true, buttonText: "جاري الإضافة ...", buttonColor: "loading" });
       // Send the data to the server
       apiFetch("/other-appointments", {
           method: "POST",
           body: {
               appointmentsType: this.state.type,
               img: this.state.formContent.thumb,
               schoolStageId: this.state.schoolStageId,
               materialId: this.state.material,
               branchId: this.state.branchID,
           },
       })
       .then(() => {
           _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تمت إضافة التعويض بنجاح'});
           // the save finished the job, so the panel closes and the table
           // behind it goes and fetches what was just added
           _this.setState({
               saving: false,
               buttonText: "إضافة تعويض",
               buttonColor: "",
               addOpen: false,
               grade: null,
               material: null,
               schoolStageId: null,
               getMaterialsList: [],
               formContent: { ..._this.state.formContent, thumb: "" },
           });
           this.allNews();
       })
       .catch(error => {
           console.error('Error:', error)
           _this.setState({ saving: false, buttonText: "إضافة تعويض", buttonColor: "" });
           _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
       });
   };

    render() {
        const { tableLoading, doomed, deleting, data } = this.state;

        let materialList = this.state.getMaterialsList.map((period) => {
            return { label: period.name, value: period.id };
          });

          const grades = this.state.allGrades.map((grade) => {
            return {
              label: grade.name,
              value: grade.id,
            };
          });

            const onUploadThumb = (e) => {
                let res = JSON.parse(e.xhr.response);
                this.setState({formContent: {
                    ...this.state.formContent,
                    thumb:res.thumb_url.split('/').pop()
                }});

                this.toast.current.show({severity: 'info', summary: 'تم بنجاح', detail: 'تم رفع الصورة المصغرة'});
            };

        var deletePeriod = (e) => {
            var _this = this;
            this.setState({ deleting: true });
            // Send the data to the server
            apiFetch(`/other-appointments/${e.id}`, { method: "DELETE" })
            .then(() => {
                this.setState({ doomed: null, deleting: false });
                _this.allNews();
                _this.toast.current.show({severity: 'success', summary: 'تم بنجاح', detail: 'تم الحذف بنجاح'});
            })
            .catch(error => {
                console.error('Error:', error)
               this.setState({ doomed: null, deleting: false });
               _this.toast.current.show({severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال'});
            });
        };

        const openAdd = () => this.setState({ addOpen: true });
        const closeAdd = () => {
            this.setState({ addOpen: false });
            this.allNews();
        };

        // materialId is the one thing the server requires
        const canSave = this.state.material !== null && this.state.material !== undefined;

        const actionBodyTemplate = (rowData) => {
            return (
                <React.Fragment>
                    <Tip text="حذف">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => this.setState({ doomed: rowData })} />
                    </Tip>
                </React.Fragment>
            );
        }

        // the row's image, only when there is one -- an empty `img` used to
        // build a src ending in "/thumb/" and render a broken picture
        const imageTable = (rowData) => {
            if (!rowData.img) {
                return <span className="ui-bits is-none">من غير صورة</span>;
            }
            return (
                <img
                    className="preview-thumb image"
                    src={`${properties.uploads_path}/thumb/${rowData.img}`}
                    alt=""
                    loading="lazy"
                    onClick={(e) => e.target.requestFullscreen()}
                />
            );
        }

        const thumb = this.state.formContent.thumb;

        return (
            <>
                <Header
                    pageName="التعويضات"
                    action={{ label: "إضافة تعويض", icon: "pi pi-plus", onClick: openAdd }}
                />
                <Toast ref={this.toast}></Toast>

                {/* The form used to be a whole Card wedged inside the table's
                    own header row. Same fields, same handler, same call --
                    they just have room to be read now. */}
                <Panel
                    visible={this.state.addOpen}
                    onHide={closeAdd}
                    title="إضافة تعويض"
                    subtitle="اختار المادة وارفع صورة التعويض، وهيظهر في الجدول بعد الحفظ"
                    actions={
                        <Button
                            className={`add-button ${this.state.buttonColor}`}
                            label={this.state.buttonText}
                            disabled={!canSave || this.state.saving}
                            onClick={this.addNews}
                        />
                    }
                >
                    <div className="add-lesson-page in-panel">
                        <div className="content">
                            <div className="container">
                                <section className="ui-sec" style={{ "--d": "0ms" }}>
                                    <h3>
                                        <span className="n">١</span>
                                        <span className="t">
                                            المادة
                                            <small>التعويض بيتبع مادة في مرحلة دراسية</small>
                                        </span>
                                    </h3>
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <Dropdown
                                                        value={this.state.grade}
                                                        options={grades}
                                                        placeholder="اختر"
                                                        onChange={(e) =>
                                                            this.setState({
                                                                schoolStageId: e.value,
                                                                grade: e.value,
                                                                material: null,
                                                            }, () => this.getMaterialByStage(e.value))
                                                        }
                                                        name="grade"
                                                        showClear
                                                        emptyMessage={<SelectEmpty loading={this.state.loadingGrades} />}
                                                    />
                                                    <label>المرحلة الدراسية</label>
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-inputgroup">
                                                <span className="p-float-label">
                                                    <Dropdown
                                                        value={this.state.material}
                                                        options={materialList}
                                                        placeholder="اختر"
                                                        onChange={(e) =>
                                                            this.setState({
                                                                material: e.value,
                                                                formContent: {
                                                                    ...this.state.formContent,
                                                                    materialId: e.value,
                                                                },
                                                            })
                                                        }
                                                        name="subject"
                                                        showClear
                                                        emptyMessage={<SelectEmpty loading={this.state.loadingMaterials} />}
                                                        // the materials belong to a stage, so there is
                                                        // nothing to choose from until one is picked
                                                        disabled={!this.state.grade}
                                                    />
                                                    <label>
                                                        المادة
                                                        {!this.state.grade ? (
                                                            <small className="ui-fieldhint">اختر المرحلة الدراسية الأول</small>
                                                        ) : null}
                                                    </label>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="ui-sec" style={{ "--d": "70ms" }}>
                                    <FileUpload
                                        name="thumb"
                                        onUpload={onUploadThumb}
                                        invalidFileSizeMessageSummary="حجم الصورة كبير:"
                                        invalidFileSizeMessageDetail="أقصى حجم للصورة هو (100 MB)"
                                        url={`${properties.uploads_path}/upload-thumb.php`}
                                        customUpload={false}
                                        multiple={false}
                                        accept="image/*"
                                        maxFileSize={1000000000}
                                        chooseLabel="إختيار صورة"
                                        uploadLabel="رفع الصورة"
                                        cancelLabel="إلغاء"
                                        // the chooser rides the section's own heading row
                                        headerTemplate={(o) => (
                                            <div className="ui-sec-head">
                                                <span className="n">٢</span>
                                                <span className="t">
                                                    صورة التعويض
                                                    <small>اختياري — صورة توضح موعد التعويض</small>
                                                </span>
                                                <span className="act">
                                                    {o.chooseButton}
                                                    {o.uploadButton}
                                                    {o.cancelButton}
                                                </span>
                                            </div>
                                        )}
                                        emptyTemplate={<p className="p-m-0">إسحب الصورة هنا ليبدأ التحميل</p>}
                                    />

                                    {/* the preview only exists once something is
                                        uploaded -- it used to render an <img> with
                                        an empty name and show a broken picture */}
                                    {thumb ? (
                                        <div className="uploaded-file-row">
                                            <img
                                                className="preview-thumb image"
                                                src={`${properties.uploads_path}/thumb/${thumb}`}
                                                alt=""
                                                onClick={(e) => e.target.requestFullscreen()}
                                            />
                                            <Button
                                                icon="pi pi-times"
                                                className="p-button-rounded p-button-text p-button-danger"
                                                onClick={() => this.setState({
                                                    formContent: { ...this.state.formContent, thumb: "" },
                                                })}
                                            />
                                        </div>
                                    ) : null}
                                </section>
                            </div>
                        </div>
                    </div>
                </Panel>

                <Confirm
                    visible={!!doomed}
                    onHide={() => this.setState({ doomed: null })}
                    name={doomed ? (this.state.materialsById[doomed.materialId] || "التعويض") : ""}
                    note="التعويض هيتشال نهائياً، ومش هينفع ترجع عنه."
                    busy={deleting}
                    onConfirm={() => deletePeriod(doomed)}
                />

                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                <Toolbar
                                    value={this.state.globalFilter || ''}
                                    onSearch={(v) => this.setState({ globalFilter: v })}
                                    placeholder="بحث في التعويضات"
                                    count={tableLoading ? null : `${data.length} تعويض`}
                                />

                                <DataTable
                                    sortable
                                    globalFilter={this.state.globalFilter}
                                    className="p-datatable-responsive-demo p-datatable-gridlines p-datatable-striped"
                                    value={data} paginator rows={10} rowsPerPageOptions={[10,20,50]}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                    emptyMessage={
                                        tableLoading ? (
                                            <TableWait />
                                        ) : (
                                            <EmptyState
                                                title="لا يوجد تعويضات"
                                                hint="ابدأ بإضافة أول موعد تعويض لمادة من موادك"
                                                icon="pi pi-calendar-plus"
                                                action={{ label: "إضافة تعويض", onClick: openAdd }}
                                            />
                                        )
                                    }>
                                    <Column
                                        sortable
                                        field="schoolStageId"
                                        body={(row) => this.state.stagesById[row.schoolStageId] || "—"}
                                        header="السنه الدراسيه"
                                    ></Column>
                                    <Column
                                        sortable
                                        field="materialId"
                                        body={(row) => this.state.materialsById[row.materialId] || "—"}
                                        header="الماده"
                                    ></Column>
                                    <Column body={imageTable} header="الصوره"></Column>
                                    <Column header="حذف" body={actionBodyTemplate}></Column>
                                </DataTable>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Reparation;
